/**
 * Piixel brand logo. The source assets in public/brand are white-on-dark;
 * generated *-light.svg copies (white → ink #0C1622, cyan gradients kept)
 * carry the light theme. Both <img>s stay in the DOM and CSS picks one via
 * html[data-theme] — theme flips need no JS or re-render here.
 */
interface Props {
  variant?: 'full' | 'mark';
  height: number;
}

const SRC = {
  full: '/brand/logo-v1-250px.svg',
  mark: '/brand/logo-only-250px.svg',
} as const;

export default function BrandLogo({ variant = 'full', height }: Props) {
  const dark = SRC[variant];
  const light = dark.replace('.svg', '-light.svg');
  // inline size: tailwind preflight (img { height: auto }) overrides the
  // height attribute, so the attribute alone renders at natural size
  const size = { height: `${height}px`, width: 'auto' } as const;
  return (
    <span className="brand">
      <img className="brand-when-light" src={light} alt="Piixel" style={size} />
      <img className="brand-when-dark" src={dark} alt="Piixel" style={size} />
    </span>
  );
}
